import React from 'react'
import PropTypes from 'prop-types'
import { Form, Button } from 'react-bootstrap'
import FormError from 'shared/components/FormError'
import SpinnerLoader from 'shared/components/Loaders/SpinnerLoader'
import {
  authenticateLoginPasskey,
  verifyLoginTotp,
} from 'Store/Auth/actions/mfaActions'

class MfaLoginVerify extends React.Component {
  constructor(props) {
    super(props)
    this.state = { code: '', error: null, loading: false }
    this.onTotpSubmit = this.onTotpSubmit.bind(this)
    this.onPasskey = this.onPasskey.bind(this)
  }

  onTotpSubmit(e) {
    e.preventDefault()
    this.setState({ loading: true, error: null })
    verifyLoginTotp(this.props.challengeId, this.state.code.trim())
      .then(resp => this.props.onSuccess(resp.data))
      .catch(err => {
        const message = err.response?.data?.detail || 'Invalid verification code.'
        this.setState({ error: { message }, loading: false })
      })
  }

  onPasskey() {
    this.setState({ loading: true, error: null })
    authenticateLoginPasskey(this.props.challengeId)
      .then(resp => this.props.onSuccess(resp.data))
      .catch(err => {
        const message = err.response?.data?.detail || err.message || 'Passkey sign-in failed.'
        this.setState({ error: { message }, loading: false })
      })
  }

  render() {
    const { methods } = this.props
    const hasTotp = methods.includes('totp')
    const hasPasskey = methods.includes('passkey')

    return (
      <div className="login-form__mfa">
        <h5 className="mb-3">Two-factor authentication</h5>
        <p className="login-form__text mb-3">Complete sign-in with your authenticator app or passkey.</p>
        <FormError show={!!this.state.error} message={(this.state.error || {}).message} />

        {hasTotp && (
          <Form onSubmit={this.onTotpSubmit}>
            <Form.Group controlId="mfaCode">
              <Form.Label>Authenticator code</Form.Label>
              <Form.Control
                value={this.state.code}
                onChange={e => this.setState({ code: e.target.value })}
                inputMode="numeric"
                autoComplete="one-time-code"
                required
              />
            </Form.Group>
            <Button className="mt-2 btn-loader" disabled={this.state.loading} variant="dark" type="submit">
              <span>Verify</span>
              <div className="button-loader__container">
                {this.state.loading && <SpinnerLoader size="20px" />}
              </div>
            </Button>
          </Form>
        )}

        {hasTotp && hasPasskey && <p className="text-center my-3 text-muted">or</p>}

        {hasPasskey && (
          <Button
            className="btn-loader w-100"
            disabled={this.state.loading}
            variant="outline-dark"
            onClick={this.onPasskey}
          >
            <span>Sign in with passkey</span>
          </Button>
        )}

        <p className="mt-3 mb-0">
          <button type="button" className="btn btn-link p-0" onClick={this.props.onBack}>
            ← Back to password
          </button>
        </p>
      </div>
    )
  }
}

MfaLoginVerify.propTypes = {
  challengeId: PropTypes.string.isRequired,
  methods: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSuccess: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default MfaLoginVerify
